(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-images-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {

	$('.featured-images-slider-slick').slick({
		prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50'><rect fill='#EEEEEE' x='0' y='0' width='50' height='50'/><polygon fill='#0B2027' transform='translate(24.000000, 25.000000) rotate(-90.000000) translate(-24.000000, -25.000000)' points='24 22 29 28 19 28'/></svg></button>",
		nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50'><rect fill='#EEEEEE' x='0' y='0' width='50' height='50'/><polygon fill='#0B2027' transform='translate(24.000000, 25.000000) rotate(90.000000) translate(-24.000000, -25.000000)' points='24 22 29 28 19 28'/></svg></button>"
	});

	var stHeight = $('.featured-images-slider-slick .slick-track').height();
	$('.featured-images-slider-slick .slick-slide').css('height',stHeight + 'px' );
	
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
	$('.featured-products-slick').each(function(){
		$(this).slick({
			lazyLoad: 'ondemand',
			prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50'><rect fill='#EEEEEE' x='0' y='0' width='50' height='50'/><polygon fill='#0B2027' transform='translate(24.000000, 25.000000) rotate(-90.000000) translate(-24.000000, -25.000000)' points='24 22 29 28 19 28'/></svg></button>",
			nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50'><rect fill='#EEEEEE' x='0' y='0' width='50' height='50'/><polygon fill='#0B2027' transform='translate(24.000000, 25.000000) rotate(90.000000) translate(-24.000000, -25.000000)' points='24 22 29 28 19 28'/></svg></button>"
		});
	});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
	$(document).ready(function() {
		$('.hero-slick').each(function(){
			var heroSlick = $(this);
			$(heroSlick).slick({
					prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50'><rect fill='#FFFFFF' x='0' y='0' width='50' height='50'/><polygon fill='#0B2027' transform='translate(24.000000, 25.000000) rotate(-90.000000) translate(-24.000000, -25.000000)' points='24 22 29 28 19 28'/></svg></button>",
					nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50'><rect fill='#FFFFFF' x='0' y='0' width='50' height='50'/><polygon fill='#0B2027' transform='translate(24.000000, 25.000000) rotate(90.000000) translate(-24.000000, -25.000000)' points='24 22 29 28 19 28'/></svg></button>"
			});
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
	$(document).ready(function() {

			$('.product-detail-images').slick({
		 		slidesToShow: 1,
  				slidesToScroll: 1,
				infinite: true,
			 	prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><path d='M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z'/></svg></button>",
				nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><path d='M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z'/></svg></button>",
				arrows: false,
				dots: true,
				asNavFor: '.product-detail-thumbnails',
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					}
				]
			});
			
			$('.product-detail-thumbnails').slick({
				vertical: true,
  			verticalSwiping: true,
		 		slidesToShow: 4,
				slidesToScroll: 1,
				infinite: true,
			 	prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><path d='M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z'/></svg></button>",
				nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><path d='M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z'/></svg></button>",
				asNavFor: '.product-detail-images',
				focusOnSelect: true,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 3
						}
					}
				]
			});

			//if user on mobile
			if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
					$('.social-sharing-products .whatsapp').removeClass('d-none');
			}
	});

  } catch(e) { console.error(e); }
})();
})();
